import { Link } from "react-router-dom";
import {
  HeadingTitle,
  Image,
  Button,
} from "../../../../../components/shared/index";
import styles from "./wishlistcard.module.css";
import { LiaRupeeSignSolid } from "react-icons/lia";
import { MdDeleteOutline } from "react-icons/md";
import toast from "react-hot-toast";
const WishListCard = ({
  item,
  onAddToCart,
  onNotifyMe,
  onRemove,
  isCartPending,
  isInCart,
    isNotified,
}) => {
  const handleAddToCart = () => {
    onAddToCart();
    onRemove();
  };

  return (
    <section className={styles.card}>
      <Link
        to={`/productdetails/${item?.productSlug}`}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.left}
      >
        <Image
          src={item?.image}
          alt={item?.title}
          width={80}
          height={80}
          className={styles.image}
        />

        <div className={styles.details}>
          <HeadingTitle text={item.title} style={styles.title} />

          <div className={styles.priceRow}>
            <span className={styles.price}>
              <LiaRupeeSignSolid size={18} />
              {item.price}
            </span>

            {item?.oldPrice && (
              <span className={styles.oldPrice}>
                <LiaRupeeSignSolid size={14} />
                {item?.oldPrice}
              </span>
            )}

            {item.offer > 0 && (
              <span className={styles.offer}>({item?.offer}% OFF)</span>
            )}
          </div>
        </div>
      </Link>

      <div className={styles.right}> 
            <button
  className={styles.deleteBtn}
  onClick={() => {
    toast.success("Item removed from wishlist");
    onRemove(); // call mutation
  }}
  title="Remove from wishlist"
>
  <MdDeleteOutline size={20} />
</button>
     {Number(item.productQuantity) === 0 ? (
  <Button
    title={
      isCartPending
        ? "Subscribing..."
        : isNotified
        ? "Notified"
        : "Notify Me"
    }
    onHandler={onNotifyMe}
    disabled={isCartPending || isNotified}
    style={`${styles.addBtn} ${
      isNotified ? styles.notifiedBtn : ""
    }`}
  />
) : (
  <Button
    title={
      isInCart
        ? "Already in Cart"
        : isCartPending
        ? "Adding..."
        : "Add to Cart"
    }
    onHandler={handleAddToCart}
    disabled={isCartPending || isInCart}
    style={styles.addBtn}
  />
)}
      </div>
    </section>
  );
};

export default WishListCard;